import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { TriggerHelpItemEvent } from '../../events';
import { fetchAndOpenHjelpeskuff } from '../hjelpeskuff';
/**
 * Oppdaterer hjelpeskuffen med ny hjelpetekst når det skjer en TriggerHelpItemEvent.
 * Brukes i forbindelse med microweb, der hjelpetriggere i microweben skal åpne hjelpeskuffen i vertikalen.
 */
const useHjelpetekstEvent = () => {
    const dispatch = useDispatch();
    const handleEvent = (event) => {
        const { tjenesteNavn, hjelpetekstId, language } = event.detail;
        dispatch(fetchAndOpenHjelpeskuff({
            tjenesteNavn,
            hjelpetekstId,
            language,
        }));
    };
    useEffect(() => {
        window.addEventListener(TriggerHelpItemEvent, handleEvent);
        return () => {
            window.removeEventListener(TriggerHelpItemEvent, handleEvent);
        };
    }, []);
};
export default useHjelpetekstEvent;
